import React from 'react';
import PropTypes from 'prop-types';
import { CirclePlusOutline } from 'AppSrc/core/components/common/svg-icons';

const OpenModalButton = ({
  openModal,
  disabled,
}) => (
  <button
    type="button"
    onClick={openModal}
    className="open-modal-button"
    disabled={disabled}
  >
    <div className="svg-container">
      <CirclePlusOutline />
    </div>
    <span>Add work information item</span>
  </button>
);

OpenModalButton.propTypes = {
  openModal: PropTypes.func,
  disabled: PropTypes.bool,
};

export { OpenModalButton };

